module.exports = __webpack_public_path__ + "static/media/personal-path.59bcad6f.webp";